import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';

import { Text } from 'src/packages/core';
import { BadgeProps } from './Badge.types';
import { getBadgeStyles, BadgeContainer } from './Badge.styles';

const Badge: React.FC<BadgeProps> = ({ type, IconComponent, text }: BadgeProps) => {
  const theme = useTheme();

  const badgeStyles = useMemo(() => {
    return getBadgeStyles(type, theme);
  }, [type, theme]);

  return (
    <BadgeContainer badgeStyles={badgeStyles}>
      {IconComponent && <IconComponent size={14} />}
      <Text variant='p3' text={text} color={'currentColor'} />
    </BadgeContainer>
  );
};

export default Badge;
